/**
 * The seam classes, in a module of their own so a SERVER component can use
 * them: `button.tsx` is a client module, and a plain object imported from a
 * client module into a server component arrives as a client reference, not an
 * object (measured: `SEAM.icon` was undefined in the strip's skeleton).
 */
export const SEAM = {
  label: {
    prev: '[clip-path:polygon(0_0,100%_0,calc(100%-18px)_100%,0_100%)] rounded-r-none pr-8 hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.35)]',
    next: '[clip-path:polygon(18px_0,100%_0,100%_100%,0_100%)] -ml-4 rounded-l-none pl-8 z-10 hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.35)]',
  },
  /** Icon halves are a joined PILL: fully rounded outer ends, a tighter cut, meant for `size="sm"`. */
  icon: {
    prev: '[clip-path:polygon(0_0,100%_0,calc(100%-14px)_100%,0_100%)] rounded-full rounded-r-none w-14 pl-3 pr-6 hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.35)]',
    next: '[clip-path:polygon(14px_0,100%_0,100%_100%,0_100%)] -ml-3 rounded-full rounded-l-none w-14 pl-6 pr-3 z-10 hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.35)]',
  },
  /** The unavailable half: dark, still shaped, never lit. */
  off: 'cursor-not-allowed border-neutral-800 bg-neutral-800 text-neutral-500 hover:border-neutral-800 hover:bg-neutral-800 hover:text-neutral-500 hover:shadow-none before:hidden',
} as const;
